<template>
  <MDBScrollbar>
    <div class="details-list">
      <SPALozenge class="project-status" :text="selectedProject.status" :variant="checkStatusVariant(selectedProject.statusId)" />
      <div class="details-info">
        <div class="info-name">Project Name</div>
        <div class="info-detail">{{ selectedProject.name }}</div>
      </div>
      <div class="details-info">
        <div class="info-name">Project Code</div>
        <div class="info-detail">{{ selectedProject.code }}</div>
      </div>
      <div class="details-info">
        <div class="info-name">Date Created</div>
        <div class="info-detail">{{ parseDate(selectedProject.createdAt) }}</div>
      </div>
      <div class="details-info">
        <div class="info-name">Last Updated On</div>
        <div class="info-detail">{{ parseDate(selectedProject.updatedAt) }}</div>
      </div>
    </div>
  </MDBScrollbar>
</template>
<style lang="scss" scoped>
.details-list {
  font-weight: 400;
  padding: 16px;
  .project-status {
    display: inline-block;
    text-transform: uppercase;
  }
  .details-info {
    padding-block: 8px;
  }
  .info-name {
    font-size: 12px;
    line-height: 16px;
    color: $neutral-200;
  }
  .info-detail {
    font-size: 14px;
    line-height: 16px;
    color: $neutral-500;
    word-break: break-all;
  }
}
</style>
<script>
import { MDBScrollbar } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import SPALozenge from '../../../../components/SPALozenge.vue';
import { parseDate } from '../../../../helpers/dateParser';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
import { checkStatusVariant } from '../../Business/ProjectTaggingBusiness';
export default {
  name: 'ProjectTaggingViewProjectDetailList',
  components: { MDBScrollbar, SPALozenge },
  setup() {
    const projectTaggingStore = useProjectTaggingStore();
    const { selectedProject } = storeToRefs(projectTaggingStore);
    return { checkStatusVariant, selectedProject, parseDate };
  },
};
</script>
